// NOTE: making these imports async for some reason does not work
import { retryWithBackoff } from "@novel/shared/utils/retryWithBackoff";
import { novelStorefrontScriptHasRunProperty } from "@vendor-storefront-shared/scriptConstants";
// NOTE: must be imported at the root level ensure proper computation of currentScriptSrc
import { currentScriptSrc } from "@vendor-storefront-global/tokenGating/utils/currentScriptSrc";
import { autoApplyStoreCredit } from "@vendor-storefront-global/autoApplyStoreCredit";
// prevent script from running twice if loaded twice on page
if (typeof window !== "undefined" && !(window === null || window === void 0 ? void 0 : window[novelStorefrontScriptHasRunProperty])) {
    window[novelStorefrontScriptHasRunProperty] = true;
    init();
    // will remove the extra script tag that we have added via Shopify's script tag API as an optimization
    // will not always work as the script may have already been executed by the time this script runs or may
    // not have been added to the HTML yet, but it is worth a try as a most-of-the-time optimization
    // NOTE: inlining function below for performance
    // function removeExtraScriptTag() {
    const WAIT_MAX = 5000;
    const CHECK_FREQUENCY = 0;
    const startTime = Date.now();
    // Get a reference to the script element you want to prevent from loading
    const intervalId = setInterval(_remove, CHECK_FREQUENCY);
    _remove();
    // eslint-disable-next-line no-inner-declarations
    function _remove() {
        const scriptToPrevent = document.querySelectorAll('script[src*="/js/novel-storefront.js"]');
        scriptToPrevent.forEach((script) => {
            // check the src of the current script (no point in removing the script we are already executing)
            // if this is not the current script, it is extra, remove it
            if (currentScriptSrc !== script.getAttribute("src")) {
                script.remove();
                clearInterval(intervalId);
            }
        });
        if (Date.now() - startTime > WAIT_MAX) {
            clearInterval(intervalId);
        }
    }
    // }
}
export async function init() {
    // kick off auto-apply + attribution ASAP (store data fetch happens within so don't need to wait for it to finish)
    autoApplyStoreCredit();
    import("@vendor-storefront-global/walletPassLinkAttribution").then(({ walletPassAttribution }) => walletPassAttribution());
    const basePromise = retryWithBackoff(() => import("@vendor-storefront-global/utils/fetchStorefrontDataFromNovel"));
    const novelStorefrontDataPromise = basePromise.then(({ fetchNovelStorefrontData }) => fetchNovelStorefrontData());
    const onReadyPromise = retryWithBackoff(() => import("@novel/shared/utils/onReady")).then(({ onReady }) => onReady);
    const storefrontStorePromise = retryWithBackoff(() => import("@vendor-storefront-global/redux/store")).then(({ storefrontStore }) => storefrontStore);
    const loadStorefrontAuthPromise = retryWithBackoff(() => import("@vendor-storefront-global/redux/actionCreators/loadStorefrontAuth")).then(({ loadStorefrontAuth }) => loadStorefrontAuth);
    let urlPromise = Promise.resolve();
    if (!URL) {
        // no types for polyfill, doesn't matter though
        urlPromise = retryWithBackoff(() => import("url-polyfill"));
    }
    await urlPromise;
    // kick this fetch off ASAP to save time, result will be cached in local storage
    novelStorefrontDataPromise.then((storefrontData) => {
        const dispatchAuthPromise = storefrontStorePromise.then((storefrontStore) => 
        // this will ensure that the cart attribute gets attached when the customer is authed
        loadStorefrontAuthPromise
            .then((loadStorefrontAuth) => storefrontStore.dispatch(loadStorefrontAuth()))
            .then((result) => ({
            result,
            storefrontStore,
        })));
        return dispatchAuthPromise;
    });
    const tagModifierPromise = novelStorefrontDataPromise.then((storefrontData) => {
        // load tag modifier if the shop is selling NFTs
        if (storefrontData === null || storefrontData === void 0 ? void 0 : storefrontData.tokenProducts.length) {
            // pre-caching translations tag modifier use
            basePromise.then(({ fetchStorefrontTranslationsData }) => fetchStorefrontTranslationsData());
            return retryWithBackoff(() => import("./tagModifier")).then((module) => module.tagModifier);
        }
    });
    const renderGateAppPromise = retryWithBackoff(() => import("@vendor-storefront-global/tokenGating")).then(({ renderGateApp }) => renderGateApp);
    const onReady = await onReadyPromise;
    onReady(function main() {
        renderGateAppPromise.then((renderGateApp) => renderGateApp());
        tagModifierPromise.then((tagModifier) => {
            if (tagModifier) {
                tagModifier();
            }
        });
    });
}
